import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';

import './TrialOfferTermsLink.scss';

const TrialOfferTermsLink = ({ intl, isBackgroundLight, isBlueUrl }) => {
  const classNames = D.createBEM('TrialOfferTermsLink', {
    lightBackground: isBackgroundLight,
    blue: isBlueUrl,
  });
  return (
    <a
      className={classNames}
      title={intl.formatMessage(PaymentsConstants.Messages.newWindowLink)}
      href={D.Utils.Route.getTrialOffersTermsUrl()}
      target='_blank'
      rel='noopener noreferrer'
      data-qa={D.Constants.QATags.PSSOTL}
    >
      <FormattedMessage {...PaymentsConstants.Messages.trialOffersLink} />
    </a>
  );
};

TrialOfferTermsLink.propTypes = {
  intl: PropTypes.object.isRequired,
  isBackgroundLight: PropTypes.bool,
  isBlueUrl: PropTypes.bool,
};

export default injectIntl(TrialOfferTermsLink);
